import { useMessageInstanceEvent } from '@atlassian/message-instance-event-frontend-client/useMessageInstanceEvent';
import { useMessageEvent } from '@post-office/message-lifecycle';
import {
	type BackendPlacementMessage,
	type FrontendPlacementMessage,
	type BackendMessageStageInput,
} from '@post-office/placement-common-v2';
import {
	PlacementBackend,
	PlacementFrontend,
} from '@post-office/placements--growth/confluence-side-nav';

import { assertMessageTemplateContext } from '../../../__generated__/validation/messageTemplateContext';
import { type MessageTemplateContext } from '../../../index';
import {
	type CreatePlacementMessageConfig,
	type BackendSyncMessageStage,
	type AnyPayload,
	type AnyBackendMessageStage,
	type AnyFrontendStage,
} from '@post-office/placement-common-v2/create-placement/types';
import { type TransformMetadataResult } from '@post-office/shared-contracts/message-template-metadata';

export const MessageBackend: (config: CreatePlacementMessageConfig) => BackendPlacementMessage<{
	transformMetadata: BackendSyncMessageStage<AnyPayload, TransformMetadataResult>;
	hydrate?: AnyBackendMessageStage;
}> = PlacementBackend.createMessageBackend(() => ({
	transformMetadata: {
		validate: assertMessageTemplateContext,
		stage: () => ({
			goalMetadata: {
				primaryGoal: {
					goalId: 'clickthrough',
				},
			},
		}),
	},
	hydrate: {
		validate: assertMessageTemplateContext,
		stage: ({
			message,
		}: BackendMessageStageInput<MessageTemplateContext>): Promise<MessageTemplateContext> => {
			message.context.testProp = `Hello ${message.context.testProp} !`;
			return Promise.resolve(message.context);
		},
	},
}));

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: AnyFrontendStage;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: assertMessageTemplateContext,
		Component: ({ handleOnDismissed }: { handleOnDismissed: () => void }) => {
			const { messageInstanceClicked } = useMessageInstanceEvent();
			const { messageDismissed } = useMessageEvent();

			const onDismissed = (): void => {
				void messageInstanceClicked({
					messageEventType: 'clicked',
					clickedElement: {
						clickIdentifier: 'confluence-side-nav-create-a-space-dismiss',
						clickedElement: 'button',
						buttonType: 'secondary',
					},
					action: {
						actionType: 'dismiss',
					},
					additionalMetadataFromFrontend: {},
				});
				void messageDismissed();
				handleOnDismissed();
			};

			return <button onClick={onDismissed}>Dismiss</button>;
		},
	},
});
